import apiClient from "../../../api/client";

/* =========================
   LEADS
========================= */
export const getLeads = (params = {}) =>
  apiClient.get(
    "/crm/leads",
    {
      params
    }
  );

export const getLead = (
  leadId
) =>
  apiClient.get(
    `/crm/leads/${leadId}`
  );

export const createLead = (
  data
) =>
  apiClient.post(
    "/crm/leads/",
    data
  );

export const updateLead = (
  leadId,
  data
) =>
  apiClient.put(
    `/crm/leads/${leadId}`,
    data
  );

export const deleteLead = (
  leadId,data
) =>
  apiClient.put(
    `/crm/leads/${leadId}/delete`,data 
  );

/* =========================
   STATUS
========================= */

export const updateLeadStatus = (
  leadId,
  status
) =>
  apiClient.patch(
    `/crm/leads/${leadId}/status`,
    {
      status
    }
  );

/* =========================
   ADDRESS
========================= */

export const updateLeadAddress = (
  leadId,
  data
) =>
  apiClient.put(
    `/crm/leads/${leadId}/address`,
    data
  );

/* =========================
   DOCUMENTS
========================= */

export const uploadLeadDocument = (
  leadId,
  data
) =>
  apiClient.post(
    `/crm/leads/${leadId}/documents`,
    data
  );

export const deleteLeadDocument = (
  leadId,
  documentId
) =>
  apiClient.delete(
    `/crm/leads/${leadId}/documents/${documentId}`
  );

/* =========================
   REMARKS
========================= */

export const addLeadRemark = (
  leadId,
  text
) =>
  apiClient.patch(
    `/crm/leads/${leadId}/remarks`,
    {
      text
    }
  );